export default __webpack_public_path__ + "static/hero-bg-57c1acf1572e7dfe63ac5f5e00153055.png";